module.exports = __webpack_public_path__ + "img/icon_hicebank.5393afc5.svg";